export const HOME_TAB_CLICK = 'nav_home_tab_click';
export const SHARE_TAB_CLICK = 'nav_share_tab_click';
export const DM_TAB_CLICK = 'nav_dm_tab_click';
export const SUPPORTERS_TAB_CLICK = 'nav_supporters_tab_click';
